// extracted by mini-css-extract-plugin
module.exports = {"desc":"service-order_desc__1q4Qb","dot":"service-order_dot__2qYHB","loadingIcon":"service-order_loadingIcon__3PF6V","spin":"service-order_spin__5Swhn"};